import React from 'react'

import { type CrossClientQueryResultCellProps } from './types'
import { useAppSelector } from '../../../../store/hooks'
import { selectCrossClientActionsByClientId } from '../../../../store/crossClient/crossClientActions'
import { selectCrossClientClients } from '../../../../store/crossClient/crossClientResults'
import { type CrossClientAction } from '../../../../models/CrossClient'
import { getUserDisplayName } from '../../../../apps/professional-app/fa/common/aifeatures/utils'
import { CRM_ACTION_REGISTRY, type CrmActionKind, resolveCrmActionKind } from '../../Actions/crmActionRegistry'
import { CrossClientActionGroupButton } from './CrossClientActionGroupButton'

export const CrossClientQueryResultActionsCell: React.FC<CrossClientQueryResultCellProps> = ({ result }) => {
  const actionsByClientId = useAppSelector(selectCrossClientActionsByClientId)
  const clients = useAppSelector(selectCrossClientClients)
  const actions = actionsByClientId[result.clientId] ?? []

  if (!actions.length) {
    return null
  }

  const groups = new Map<CrmActionKind, CrossClientAction[]>()
  for (const action of actions) {
    const kind = resolveCrmActionKind(action)
    if (!kind) {
      continue
    }
    const list = groups.get(kind) ?? []
    list.push(action)
    groups.set(kind, list)
  }

  if (!groups.size) {
    return null
  }

  const clientName = getUserDisplayName(clients[result.clientId])

  return (
    <div className='zocks-py-0.75 flex-1 d-flex align-items-center gap-2'>
      {Array.from(groups.entries()).map(([kind, kindActions]) => (
        <CrossClientActionGroupButton key={kind} kind={kind} descriptor={CRM_ACTION_REGISTRY[kind]} actions={kindActions} clientName={clientName} />
      ))}
    </div>
  )
}
